import { getLocale } from "../runtime";

const sv_czcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tjeckien`
};

const czcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_czcountry(inputs)
	return "czCountry";
};

export { czcountry as "czCountry" };